module.exports = __webpack_public_path__ + "img/f66.68e9064c.png";